import { render, staticRenderFns } from "./ShipmentsImport.vue?vue&type=template&id=37ad1c16&scoped=true"
import script from "./ShipmentsImport.vue?vue&type=script&lang=js"
export * from "./ShipmentsImport.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsImport.vue?vue&type=style&index=0&id=37ad1c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad1c16",
  null
  
)

export default component.exports